"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useMouseSet = () => {
  const [mouseSet, setMouse] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const checkForMouseDown = e => {
      if (e?.type === "mousedown") {
        setMouse(true);
      }
    };
    const checkForTab = e => {
      if (e?.keyCode === 9) {
        setMouse(false);
      }
    };
    const checkForMouse = () => {
      // must check if document exists due to Gatsby - documentation recommendation: https://www.gatsbyjs.com/docs/debugging-html-builds/
      if (typeof document !== "undefined") {
        document.body.addEventListener("mousedown", checkForMouseDown);
        document.body.addEventListener("keydown", checkForTab);
      }
    };
    const removeEventListeners = () => {
      if (typeof document !== "undefined") {
        document.body.removeEventListener("keydown", checkForTab);
        document.body.removeEventListener("mousedown", checkForMouseDown);
      }
    };
    checkForMouse();
    return () => {
      removeEventListeners();
    };
  }, []);
  return {
    mouseSet
  };
};
var _default = useMouseSet;
exports.default = _default;